<template>
    <section class="content">
        <div class="container-fluid">
            <div class="card">
                <div class="fn-header">
                    การจัดการรูป UID
                </div>


                <div class="row search-section">
                    <div class="col-sm-2 col-search">

                        <button type="button" class="btn bg-teal waves-effect btn-search" @click="add()">
                            <i class="material-icons">add_box</i>
                            <span>สร้างรูป UID</span>
                        </button>

                    </div>
                    <div class="col-sm-5 col-search"></div>
                    <div class="col-sm-2 col-search">
                        <input type="text" class="search-textbox" v-model="key"
                            placeholder="กรุณากรอกชื่อเกม เพื่อค้นหา" style="width:100%;margin-top:5px">
                    </div>

                    <div class="col-sm-2 col-search">
                        <button type="button" class="btn bg-blue-grey  waves-effect btn-search" :disabled="searching"
                            @click="search(1)">
                            <i class="material-icons">search</i>
                            <span>ค้นหา</span>
                        </button>
                    </div>
                    <div class="col-sm-1 col-search">
                        <button type="button" class="btn bg-grey waves-effect btn-search" :disabled="searching"
                            @click="reset()">
                            <i class="material-icons">refresh</i>
                            <span>Reset</span>
                        </button>
                    </div>

                </div>
                <div class="row ">
                    <div class="col-sm-12 " style="text-align: right;">
                        <img src="static/images/excel.png" class="excel-icon" alt="download excel"
                            style="margin-right: 15px;cursor: pointer;" @click="download()" />
                    </div>
                </div>
                <div class="body table-responsive" style="width:100%">
                    <div class="preloader pl-size-xl" v-if="searching == true || loading == true">
                        <div class="spinner-layer pl-orange">
                            <div class="circle-clipper left">
                                <div class="circle"></div>
                            </div>
                            <div class="circle-clipper right">
                                <div class="circle"></div>
                            </div>
                        </div>
                    </div>
                    <div v-else>


                        <table class="table table-bordered">
                            <thead>
                                <tr>
                                    <th class="fn-th" style="width: 80px;">No.</th>
                                    <th class="fn-th">รูปภาพ</th>
                                    <th class="fn-th">เกม</th>
                                    <th class="fn-th">ลบ</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, index) in items" :key="'p-' + item.id"
                                    :class="{ 'fn-tr-light': index % 2, 'fn-tr-dark': !(index % 2) }">
                                    <td v-html="((page-1) * perpage) + index + 1"></td>
                                    <td style="text-align: center;">

                                        <img :src="item.image" :alt="item.game_name"  style="width: 100px;" v-if="item.image != null"/>

                                    </td>

                                    <td style="text-align: center;">
                                        <span>{{ item.game_name }}</span>
                                    </td>

                                   
                                   

                            
                                    <td>
                                        <span @click="del(item.id)">
                                            <a href="#">
                                                <i class="material-icons fn-icon" style="color:red;">cancel</i>
                                            </a>
                                        </span>
                                    </td>

                                </tr>
                            </tbody>

                        </table>
                    </div>

                    <Paginate v-model=page :page-count=pages :page-range="5" :click-handler="search" :prev-text="'Prev'"
                        :next-text="'Next'" :container-class="'fn-pagination'" />

                  
                </div>
            </div>
        </div>
        <div class="modal fade" id="game-modal" tabindex="-1" role="dialog">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header" style="padding:10px">

                        <span style="color: #466aa7;font-size: 15px;font-weight: bold;">สร้างรูป UID</span>
                    </div>
                </div>
                <div class="modal-body" style="background:white;min-height: 0;">

                    <div class="row" style="margin-top:20px">
                        <div class=" col-sm-2"></div>
                        <div class="col-sm-10" style="text-align: center;">
                            
                             <div style="margin-top: 15px;" v-if="image">
                                <img :src="image" class="img-box" alt="i-game"/>
                                <div style="margin-top: 10px;">
                                <i class="material-icons del-image-icon" @click="deleteImage()">clear</i>
                                </div>
                             </div>
                             <div v-else>
                                <button class="file-upload-btn" type="button" @click="uploadClick()">+เพิ่มรูปภาพ</button>
                                 <input class="file-upload-input" type='file' ref="uploadFile"
                                @change="handleFilesUpload(this);" accept="image/*" />
                            </div>
                        </div>

                    </div>


                    <div class="row" style="margin-top: 15px;">
                        <div class="col-sm-2  col-label">
                            <span>เกม</span>
                        </div>
                        <div class="col-sm-10">
                           
                            <select v-model="game_id" class="form-control  show-tick fn-required">
                                <option :value="0">เลือกเกม</option>
                                 <option v-for="(value,index) in games" :key="'game-key-' + index" :value="value.id" v-html="value.game_name"></option>
                            </select>
                        </div>
                    </div>
                    
                </div>
                <div class="modal-footer" style="background:white">
                    <button type="button" class="btn btn-primary waves-effect" style="width: 150px;"
                        @click="handleSave()">บันทึก</button>
                    <button type="button" class="btn btn-default waves-effect" style="width: 150px;"
                        data-dismiss="modal">ปิด</button>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import GameService from '../../service/GameService'
import UidImageService from '../../service/UidImageService'
import helper from '../../classes/helper'
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import moment from 'moment'
import alertBox from '../../classes/alertBox'
import Paginate from 'vuejs-paginate'

export default {
    name: "UidImageManage",
    components: {
        DatePicker,
        Paginate
    },
    data() {
        return {
            user: JSON.parse(localStorage.getItem('user')),
            page: 1,
            perpage: 25,
            total: 0,
            pages: 0,
            game_id:0,
            items: [],
            games: [],
            image: "",
            key: "",
            file: null,
            searching: false,
            loading: false,
            search_params: {}
        }
    },
    async created() {
        await this.getGames()
        await this.search(1)
    },
    mounted() {

    },
    methods: {
        async getGames() {
            let response = await GameService.get()
            console.log("getGames", response)
            if(response.status){
                this.games = response.result
            }
        },
        async search(p = 0) {
            this.loading = true
            if (p > 0) {
                this.page = p
            }
            let response = await UidImageService.search(this.key, this.page, this.perpage)
          
            if (response.status) {
                let { page, perpage, total, pages, data } = response.result
                this.page = Number(page)
                this.perpage = Number(perpage)
                this.total = Number(total)
                this.pages = Number(pages)
                this.items = data

            }
            this.loading = false
        },
        reset(p = 1) {
            this.key = ""
            this.game_id = 0
            this.image = ""
            this.file = null
            this.search(p)
        },
        add() {
            this.game_id = 0
            this.image = ""
            this.file = null
            $('#game-modal').modal('show')
        },
        async handleSave() {
            if (!this.validate()) {
                return false
            }

            await this.create()
            
            
            $('#game-modal').modal('hide')
        },
        validate() {
                if (!this.game_id) {
                    alertBox.error("กรุณาเลือกเกม")
                    return false
                }
            if (!this.image && !this.file) {
                alertBox.error("กรุณาเลือกไฟล์รูปภาพ")
                return false
            }
            

            return true
        },
        async create() {
            try {
                console.log(this.game_id)
                let formData = new FormData();
                formData.append('gameId', this.game_id);
                formData.delete('file');
                if (this.file) {
                    formData.append('file', this.file);
                }

                let response = await UidImageService.create(formData)
               
                if (response.status) {
                    alertBox.success('save success')
                    this.reset(this.page)
                }
                else {
                    alertBox.error("Error, " + response.error)
                }
            }
            catch (error) {
                alertBox.error("Error, " + error)
            }
        },
        async del(id) {
        console.log("delete id", id)
            let result = await alertBox.confirm('คุณแน่ใจที่จะลบ?')
            if (result) {
                let data = {
                    id: id
                }
                let response = await UidImageService.delete(data)

                if (response.status) {
                    this.reset(this.page)
                }
                else {
                    alertBox.error("Error, " + response.error)
                }
            }
        },
         uploadClick(){
            this.$refs.uploadFile.click()
        },
        handleFilesUpload() {
             let uploadedFiles = this.$refs.uploadFile.files;
            this.image = URL.createObjectURL(uploadedFiles[0])
            this.file = uploadedFiles[0]
            this.$refs.uploadFile.value = ""
        },
        validateFile(file) {
            
            if (file.size > this.max_file_size) {
                let size = this.max_file_size / 1000000
                alertBox.error(`กรุณาเลือกขนาดขนาดไฟล์ ไม่เกิน ${size} mb`)
                return false
            }

            if (!file.type) {
                alertBox.error(`ชนิดของไฟล์ไม่ถูกต้อง<br>ไม่อนญาตไฟล์ ${file.name} ขึ้นสู่ระบบ`)
                return false
            }

            let ext = file.name.split('.').reverse()[0].toLowerCase()
            if (!this.file_extensions.includes(ext)) {
                alertBox.error(`ชนิดของไฟล์ไม่ถูกต้อง<br>ไม่อนญาตไฟล์ ${file.name} ขึ้นสู่ระบบ`)
                return false
            }

            return true
        },
        async deleteImage() {
            const result = await alertBox.confirm('Are you sure to delete?')
            
            if (result) {
                this.image = ""
            }

        },

    },
    filters: {
        comma(value) {
            return helper.WithComma(value)
        },
        date(value) {
            if (!value) return ""

            return moment(value).format('DD/MM/YYYY HH:mm')
        }
    }
}
</script>

<style scoped>
.clear-img{
        cursor: pointer;
        color:red;
        font-size:16px;
        vertical-align: middle;
    }
    .img-box{
        cursor: zoom-in;
        max-height : 160px;
    }
    
    .file-upload {
        background-color: #ffffff;
        width: 600px;
        margin: 0 auto;
        padding: 20px;
    }

    .file-upload-btn {
        width: 100%;
        color: #2196f3;
        background: #fff;
        border: 1px dashed #2196f3;
        padding: 10px;
        border-radius: 4px;
        /* border-bottom: 4px solid #15824B; */
        transition: all .2s ease;
        outline: none;
        text-transform: uppercase;
        font-weight: 700;
    }

    .file-upload-btn:hover {
        background: #2196f3;
        color: #ffffff;
        transition: all .2s ease;
        cursor: pointer;
    }

    .file-upload-btn:active {
        border: 0;
        transition: all .2s ease;
    }

    .file-upload {
        background-color: #ffffff;
        width: 600px;
        margin: 0 auto;
        padding: 20px;
    }

    .file-upload-content {
        display: none;
        text-align: center;
    }

    .file-upload-input {
        position: absolute;
        margin: 0;
        padding: 0;
        width: 100%;
        height: 100%;
        outline: none;
        opacity: 0;
        cursor: pointer;
    }   

    .image-title-wrap {
        padding: 0 15px 15px 15px;
        color: #222;
    }

    .file-upload-image {
        max-height: 200px;
        max-width: 200px;
        margin: auto;
        padding: 20px;
    }
    .del-image-icon{
        color: red;
        cursor: pointer;
        font-size: 21px;
    }
   
</style>


// WEBPACK FOOTER //
// src/components/Manage/UidImage.vue